<template>
  <div v-loading="loading">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-8">
                <h5 class="card-title">Tagesreport {{ reportDateHeader }}</h5>
              </div>
              <div class="col-sm-4 text-right">
            <div class="row">
              <div class="col-md-6" v-if="role == 3">
            </div>
              <div class="col">
              <div>
                  <el-date-picker
                    v-model="reportDateTimeStart"
                    type="date"
                    placeholder="Datum wählen"
                    :clearable="false"
                    :picker-options="pickerOptions1"
                    format="dd.MM.yyyy"
                    @change="loadReport"
                  >
                  </el-date-picker>
                </div>
              </div>
            </div>
          </div>
            </div>
          </div>
          <div class="card-body row pb-3">
            <div class="col-md-3"><b>Verantwortlicher:</b> {{ HT }}</div>
            <div class="col-md-2">
              <b>Geöffnet:</b> {{ Open }}<br /><b>Geschlossen:</b> {{ Close }}
            </div>
            <div class="col-md-2"><b>Wetter:</b> {{ Weather }}</div>
            <div class="col"><b>Mitarbeiter:</b> {{ Trainer }}</div>
          </div>
          <div class="card-body row pb-3" v-if="location === 'DA' && Toiletten">
            <div class="col">
              <b>Toiletten-Reinigung: </b>
              <span :class="{'text-success': Toiletten === 'Reinigung wurde mängelfrei durchgeführt', 'text-warning': Toiletten !== 'Reinigung wurde mängelfrei durchgeführt'}">{{ Toiletten }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-9">
                <h6 class="card-title">Besondere Vorkommnisse</h6>
              </div>
            </div>
          </div>
          <div class="card-body row">
            <div class="col">
              <p style="white-space: pre-line;">{{ BesondereVorkommnisse }}</p>
            </div>
          </div>
        </div>
<!--
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-9">
                <h6 class="card-title">Einweisungen</h6>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row pb-3">
              <div class="col-sm-4">
                <el-statistic title="Anzahl" :value=EinweisungenCount group-separator="." :precision="0"></el-statistic>
              </div>
              <div class="col-sm-4">
                <el-statistic title="Teilnehmer" :value=EinweisungenPersons group-separator="." :precision="0"></el-statistic>
              </div>
              <div class="col-sm-4">
                <el-statistic title="Durschschn. Teilnehmer" :value=EinweisungenAvgPersons group-separator="." decimal-separator="," :precision="0"></el-statistic>
              </div>
            </div>
            <div class="row">
              <div class="col text-right">
                <p-button type="default" @click="viewEinweisungen" class="mt-3"><i class="bi bi-eye"></i> Einweisungsprotokoll</p-button>
              </div>
            </div>
          </div>
        </div>-->

        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-9">
                <h6 class="card-title">Kassenstart</h6>
              </div>
            </div>
          </div>
          <div class="card-body row">
            <div class="col">
              <collapse>
                <collapse-item
                  v-for="(start) in Kassenstart"
                  :title="start.Title"
                  :name="start.Title"
                  :key="start.Title"
                >
                  <div>
                    <div class="row">
                      <div class="col"><b>Trainer:</b></div>
                      <div class="col text-right">
                        {{
                          start.Trainer
                        }}
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Uhrzeit:</b></div>
                      <div class="col text-right">
                        {{
                          start.Timestamp
                        }} Uhr
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Wechselgeld:</b></div>
                      <div class="col text-right">
                        <span v-if="start.WechselgeldKorrekt == 'Korrekt'" style="color: green"><b>
                          {{
                            start.WechselgeldKorrekt
                          }}
                        </b></span>
                        <span v-else style="color: red"><b>
                          {{
                            start.WechselgeldKorrekt
                          }}
                        </b></span>
                        
                      </div>
                    </div>
                    <div class="row mt-2" v-if="start.WechselgeldKorrekt == 'Nicht korrekt'">
                      <div class="col"><b>Beschreibung der Abweichung:</b></div>
                      <div class="col text-right">
                        {{
                          start.Abweichung
                        }}
                      </div>
                    </div>
                  </div>
                </collapse-item>
              </collapse>
            </div>
          </div>
        </div>
        
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-9">
                <h6 class="card-title">Kassenabschlüsse</h6>
              </div>
            </div>
          </div>
          <div class="card-body row">
            <div class="col">
              <collapse>
                <collapse-item
                  v-for="(abschluss, index) in Kasse"
                  :title="abschluss.Title"
                  :name="abschluss.Title"
                  :key="abschluss.Title"
                >
                  <div>
                    <div class="row">
                      <div class="col"><b>Aktueller Kassenbestand:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.Kassenbestand.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                      </div>
                    </div>
                    <div class="row mt-1" v-if="hasDenomination(abschluss.KassenbestandDenomination)">
                      <div class="col"></div>
                      <div class="col text-right">
                        <a
                          href="#"
                          class="denomination-toggle"
                          @click.prevent="toggleDenomination(index, 'kassenbestand')"
                        >
                          {{ isDenominationVisible(index, 'kassenbestand') ? "Stückelung ausblenden" : "Stückelung anzeigen" }}
                        </a>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-if="isDenominationVisible(index, 'kassenbestand') && hasDenomination(abschluss.KassenbestandDenomination)"
                    >
                      <div class="col-12">
                        <div class="denomination-box">
                          <div
                            v-for="entry in getDenominationEntries(abschluss.KassenbestandDenomination)"
                            :key="`kb-${abschluss.Title}-${entry.key}`"
                            class="denomination-chip"
                          >
                            <div class="denomination-chip-label">{{ entry.label }}</div>
                            <div class="denomination-chip-count">{{ entry.count }}x</div>
                            <div class="denomination-chip-total">{{ formatMoney(entry.totalValue) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Kassenstartbetrag:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.Wechselgeldstart.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Kartenzahlungen:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.ECSchnitt.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                        ({{ abschluss.ECPercent.toFixed(0) + " %" }})
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Gutscheine:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.Gutscheine.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }} ({{ abschluss.GutscheineAnzahl.toFixed(0) }})
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Stornos:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.Stornos.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }} ({{ abschluss.StornosAnzahl.toFixed(0) }})
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Online bezahlt:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.Online.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                        ({{ abschluss.OnlinePercent.toFixed(0) + " %" }})
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Soll-Bestand:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.SollBestand.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Kassendifferenz:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.Kassendifferenz.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col">
                        <b>Wechselgeld nach Kassenabrechnung:</b>
                      </div>
                      <div class="col text-right">
                        {{
                          abschluss.WechselgeldEnde.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                      </div>
                    </div>
                    <div class="row mt-1" v-if="hasWechselgeldDenomination(abschluss)">
                      <div class="col"></div>
                      <div class="col text-right">
                        <a
                          href="#"
                          class="denomination-toggle"
                          @click.prevent="toggleDenomination(index, 'wechselgeld')"
                        >
                          {{ isDenominationVisible(index, 'wechselgeld') ? "Stückelung ausblenden" : "Stückelung anzeigen" }}
                        </a>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-if="isDenominationVisible(index, 'wechselgeld') && hasWechselgeldDenomination(abschluss)"
                    >
                      <div class="col-12">
                        <div class="denomination-box">
                          <div
                            v-for="entry in getWechselgeldDenominationEntries(abschluss)"
                            :key="`wg-${abschluss.Title}-${entry.key}`"
                            class="denomination-chip"
                          >
                            <div class="denomination-chip-label">{{ entry.label }}</div>
                            <div class="denomination-chip-count">{{ entry.count }}x</div>
                            <div class="denomination-chip-total">{{ formatMoney(entry.totalValue) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Ausgaben (Gesamtbetrag):</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.Ausgaben.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Summe der Rechnungen:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.SummeRechnungen.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Umsatz gesamt:</b></div>
                      <div class="col text-right">
                        <b>{{
                          abschluss.ZFin.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}</b>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Bankeinzahlung (Entnahme):</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.Bankeinzahlung.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                      </div>
                    </div>
                    <div class="row mt-1" v-if="hasDenomination(abschluss.BankeinzahlungDenomination, { banknotesOnly: true })">
                      <div class="col"></div>
                      <div class="col text-right">
                        <a
                          href="#"
                          class="denomination-toggle"
                          @click.prevent="toggleDenomination(index, 'bankeinzahlung')"
                        >
                          {{ isDenominationVisible(index, 'bankeinzahlung') ? "Scheinstückelung ausblenden" : "Scheinstückelung anzeigen" }}
                        </a>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-if="isDenominationVisible(index, 'bankeinzahlung') && hasDenomination(abschluss.BankeinzahlungDenomination, { banknotesOnly: true })"
                    >
                      <div class="col-12">
                        <div class="denomination-box">
                          <div
                            v-for="entry in getDenominationEntries(abschluss.BankeinzahlungDenomination, { banknotesOnly: true })"
                            :key="`be-${abschluss.Title}-${entry.key}`"
                            class="denomination-chip"
                          >
                            <div class="denomination-chip-label">{{ entry.label }}</div>
                            <div class="denomination-chip-count">{{ entry.count }}x</div>
                            <div class="denomination-chip-total">{{ formatMoney(entry.totalValue) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Gesamt unbar bezahlt:</b></div>
                      <div class="col text-right">
                        {{
                          abschluss.CashlessTotal.toFixed(2)
                            .replace(".", ",")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
                        }}
                        ({{ abschluss.CashlessPercent.toFixed(0) + " %" }})
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Kasse gegengezählt durch:</b></div>
                      <div class="col text-right">
                        {{ abschluss.TrainerRecount }}
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Bankeinzahlung durch:</b></div>
                      <div class="col text-right">
                        {{ abschluss.TrainerBankeinzahlung }}
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col"><b>Kassenabschluss:</b></div>
                      <div class="col text-right">
                        {{ abschluss.KassenTrainer }}
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col">
                        <b>Erstellt:</b>
                      </div>
                      <div class="col text-right">
                        {{ abschluss.Timestamp }} Uhr
                      </div>
                    </div>
                    <div class="row mt-4" v-if="abschluss.isValid">
                      <div class="col">
                        
                      </div>
                      <div class="col text-right">
                        <p-button type="default" @click="editKasse(index)">
                    <i class="fa fa-edit"></i> Bearbeiten
                  </p-button>
                      </div>
                    </div>
                  </div>
                </collapse-item>
              </collapse>
            </div>
          </div>
        </div>

        <div class="">
          <time-line type="simple">
            <time-line-item
              class="timeline-inverted"
              v-for="anmerkung in Anmerkungen"
              :key="anmerkung.key"
              :badgeType="anmerkung.type"
              badgeIcon="nc-icon nc-single-copy-04"
            >
              <badge slot="header" type="danger" v-if="anmerkung.important"
                >Wichtig!</badge
              >
              <p slot="content">{{ anmerkung.text }}</p>

              <h6 slot="footer" class="pt-2">
                <i class="fa fa-clock-o"></i>
                {{ anmerkung.timestamp }} Uhr
              </h6>
            </time-line-item>
          </time-line>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-9">
                <h6 class="card-title">Checklisten</h6>
              </div>
            </div>
          </div>
          <div class="card-body row">
            <div class="col">
              <collapse>
                <collapse-item title="Betriebsbeginn HT" name="HTStart">
                  <div class="col-sm-12">
                    <el-table
                      :data="HTStart"
                      header-row-class-name="text-primary"
                      empty-text="Checkliste wurde nicht ausgefüllt."
                    >
                      <el-table-column
                        prop="Task"
                        label="Aufgabe"
                        width="300"
                      ></el-table-column>
                      <el-table-column
                        prop="checked"
                        label="Erledigt"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.checked" class="text-center">
                            <i
                              class="bi bi-check-circle-fill"
                              style="font-size: 1.2rem; color: green"
                            ></i>
                          </div>
                          <div v-if="!scope.row.checked" class="text-center">
                            <i
                              class="bi bi-x-circle-fill"
                              style="font-size: 1.2rem; color: red"
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="value"
                        label="Wert"
                      ></el-table-column>
                      <el-table-column
                        prop="note"
                        label="Anmerkung"
                        min-width="200"
                      >
                        <template slot-scope="scope">
                          <span v-if="scope.row.note" class="checklist-note">
                            <i class="bi bi-chat-left-text"></i>
                            {{ scope.row.note }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="row pt-4 pl-2" v-if="HTStartProcessedBy.length > 0">
                      <i>Ausgefüllt von: {{ HTStartProcessedBy }}</i>
                    </div>
                  </div>
                </collapse-item>
                <collapse-item title="Betriebsbeginn Kasse" name="KasseStart">
                  <div class="col-sm-12">
                    <el-table
                      :data="KasseStart"
                      header-row-class-name="text-primary"
                      empty-text="Checkliste wurde nicht ausgefüllt."
                    >
                      <el-table-column
                        prop="Task"
                        label="Aufgabe"
                        width="300"
                      ></el-table-column>
                      <el-table-column
                        prop="checked"
                        label="Erledigt"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.checked" class="text-center">
                            <i
                              class="bi bi-check-circle-fill"
                              style="font-size: 1.2rem; color: green"
                            ></i>
                          </div>
                          <div v-if="!scope.row.checked" class="text-center">
                            <i
                              class="bi bi-x-circle-fill"
                              style="font-size: 1.2rem; color: red"
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="value"
                        label="Wert"
                      ></el-table-column>
                    </el-table>
                    <div class="row pt-4 pl-2" v-if="KasseStartProcessedBy.length > 0">
                      <i>Ausgefüllt von: {{ KasseStartProcessedBy }}</i>
                    </div>
                  </div>
                </collapse-item>
                <collapse-item title="Betriebsende HT" name="HTEnde">
                  <div class="col-sm-12">
                    <el-table
                      :data="HTEnde"
                      header-row-class-name="text-primary"
                      empty-text="Checkliste wurde nicht ausgefüllt."
                    >
                      <el-table-column
                        prop="Task"
                        label="Aufgabe"
                        width="300"
                      ></el-table-column>
                      <el-table-column
                        prop="checked"
                        label="Erledigt"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.checked" class="text-center">
                            <i
                              class="bi bi-check-circle-fill"
                              style="font-size: 1.2rem; color: green"
                            ></i>
                          </div>
                          <div v-if="!scope.row.checked" class="text-center">
                            <i
                              class="bi bi-x-circle-fill"
                              style="font-size: 1.2rem; color: red"
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="value"
                        label="Wert"
                      ></el-table-column>
                      <el-table-column
                        prop="note"
                        label="Anmerkung"
                        min-width="200"
                      >
                        <template slot-scope="scope">
                          <span v-if="scope.row.note" class="checklist-note">
                            <i class="bi bi-chat-left-text"></i>
                            {{ scope.row.note }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="row pt-4 pl-2" v-if="HTEndeProcessedBy.length > 0">
                      <i>Ausgefüllt von: {{ HTEndeProcessedBy }}</i>
                    </div>
                  </div>
                </collapse-item>
                <collapse-item title="Betriebsende Kasse" name="KasseEnde">
                  <div class="col-sm-12">
                    <el-table
                      :data="KasseEnde"
                      header-row-class-name="text-primary"
                      empty-text="Checkliste wurde nicht ausgefüllt."
                    >
                      <el-table-column
                        prop="Task"
                        label="Aufgabe"
                        width="300"
                      ></el-table-column>
                      <el-table-column
                        prop="checked"
                        label="Erledigt"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.checked" class="text-center">
                            <i
                              class="bi bi-check-circle-fill"
                              style="font-size: 1.2rem; color: green"
                            ></i>
                          </div>
                          <div v-if="!scope.row.checked" class="text-center">
                            <i
                              class="bi bi-x-circle-fill"
                              style="font-size: 1.2rem; color: red"
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="value"
                        label="Wert"
                      ></el-table-column>
                    </el-table>
                    <div class="row pt-4 pl-2" v-if="KasseEndeProcessedBy.length > 0">
                      <i>Ausgefüllt von: {{ KasseEndeProcessedBy }}</i>
                    </div>
                  </div>
                </collapse-item>
                <collapse-item title="Veranstaltung Start" name="VAStart" v-if="VAStart.length > 0">
                  <div class="col-sm-12">
                    <el-table
                      :data="VAStart"
                      header-row-class-name="text-primary"
                      empty-text="Checkliste wurde nicht ausgefüllt."
                    >
                      <el-table-column
                        prop="Task"
                        label="Aufgabe"
                        width="300"
                      ></el-table-column>
                      <el-table-column
                        prop="checked"
                        label="Erledigt"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.checked" class="text-center">
                            <i
                              class="bi bi-check-circle-fill"
                              style="font-size: 1.2rem; color: green"
                            ></i>
                          </div>
                          <div v-if="!scope.row.checked" class="text-center">
                            <i
                              class="bi bi-x-circle-fill"
                              style="font-size: 1.2rem; color: red"
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="value"
                        label="Wert"
                      ></el-table-column>
                    </el-table>
                    <div class="row pt-4 pl-2" v-if="VAStartProcessedBy.length > 0">
                      <i>Ausgefüllt von: {{ VAStartProcessedBy }}</i>
                    </div>
                  </div>
                </collapse-item>
                <collapse-item title="Veranstaltung Ende" name="VAEnde" v-if="VAEnde.length > 0">
                  <div class="col-sm-12">
                    <el-table
                      :data="VAEnde"
                      header-row-class-name="text-primary"
                      empty-text="Checkliste wurde nicht ausgefüllt."
                    >
                      <el-table-column
                        prop="Task"
                        label="Aufgabe"
                        width="300"
                      ></el-table-column>
                      <el-table-column
                        prop="checked"
                        label="Erledigt"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.checked" class="text-center">
                            <i
                              class="bi bi-check-circle-fill"
                              style="font-size: 1.2rem; color: green"
                            ></i>
                          </div>
                          <div v-if="!scope.row.checked" class="text-center">
                            <i
                              class="bi bi-x-circle-fill"
                              style="font-size: 1.2rem; color: red"
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="value"
                        label="Wert"
                      ></el-table-column>
                    </el-table>
                    <div class="row pt-4 pl-2" v-if="VAEndeProcessedBy.length > 0">
                      <i>Ausgefüllt von: {{ VAEndeProcessedBy }}</i>
                    </div>
                  </div>
                </collapse-item>
                <collapse-item title="Büro" name="Buero" v-if="Buero.length > 0">
                  <div class="col-sm-12">
                    <el-table
                      :data="Buero"
                      header-row-class-name="text-primary"
                      empty-text="Checkliste wurde nicht ausgefüllt."
                    >
                      <el-table-column
                        prop="Task"
                        label="Aufgabe"
                        width="300"
                      ></el-table-column>
                      <el-table-column
                        prop="checked"
                        label="Erledigt"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.checked" class="text-center">
                            <i
                              class="bi bi-check-circle-fill"
                              style="font-size: 1.2rem; color: green"
                            ></i>
                          </div>
                          <div v-if="!scope.row.checked" class="text-center">
                            <i
                              class="bi bi-x-circle-fill"
                              style="font-size: 1.2rem; color: red"
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="value"
                        label="Wert"
                      ></el-table-column>
                    </el-table>
                    <div class="row pt-4 pl-2" v-if="BueroProcessedBy.length > 0">
                      <i>Ausgefüllt von: {{ BueroProcessedBy }}</i>
                    </div>
                  </div>
                </collapse-item>
                <collapse-item title="Hüttencheckliste" name="Huette" v-if="Huette.length > 0">
                  <div class="col-sm-12">
                    <el-table
                      :data="Huette"
                      header-row-class-name="text-primary"
                      empty-text="Checkliste wurde nicht ausgefüllt."
                    >
                      <el-table-column
                        prop="Task"
                        label="Zu prüfen"
                        width="300"
                      ></el-table-column>
                      <el-table-column
                        prop="checked"
                        label="Wird benötigt"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.checked" class="text-center">
                            <i
                              class="bi bi-check-circle-fill"
                              style="font-size: 1.2rem; color: green"
                            ></i>
                          </div>
                          <div v-if="!scope.row.checked" class="text-center">
                            <i
                              class="bi bi-x-circle-fill"
                              style="font-size: 1.2rem; color: red"
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="value"
                        label="benötigte Menge"
                      ></el-table-column>
                    </el-table>
                    <div class="row pt-4 pl-2" v-if="HuetteProcessedBy.length > 0">
                      <i>Ausgefüllt von: {{ HuetteProcessedBy }}</i>
                    </div>
                  </div>
                </collapse-item>
              </collapse>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-9">
                <h6 class="card-title">Parcours</h6>
              </div>
            </div>
          </div>
          <div class="card-body row">
            <div class="col-sm-12">
              <el-table
                :data="Parcours"
                header-row-class-name="text-primary"
                empty-text="Checkliste wurde nicht ausgefüllt."
              >
                <el-table-column prop="Name" label="Parcours"></el-table-column>
                <el-table-column
                  prop="Inspector"
                  label="Prüfer"
                ></el-table-column>
                <el-table-column
                  prop="Condition"
                  label="Zustand"
                ><template slot-scope="scope">
                  <span v-if="scope.row.Condition == 'Gut'">{{ scope.row.Condition }}</span>
                  <el-tooltip v-else :content="scope.row.Note" placement="left">
                    <span>{{ scope.row.Condition }}</span>
                  </el-tooltip>
                </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal :show.sync="modals.editKassenabschluss" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">
        Kassenabschluss {{ editKassenabschlussTitle }} bearbeiten
      </h5>
      <div class="row">
        <label class="col-md-6 col-form-label">Aktueller Kassenbestand</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussKassenbestand" min="0">
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">Kassenstartbetrag</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussWechselgeldstart" min="0">
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">EC-Kassenschnitt</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussEC" min="0">
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">Gutscheine</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussGutscheineAnzahl" min="0">
            <template slot="addonRight">Gutscheine</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label"></label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussGutscheine" min="0">
            <template slot="addonLeft">Summe</template>
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">Stornos</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussStornosAnzahl" min="0">
            <template slot="addonRight">Stornos</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label"></label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussStornos" min="0">
            <template slot="addonLeft">Summe</template>
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">Online bezahlt</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussOnline" min="0">
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">Soll-Bestand</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussSoll" min="0">
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">Wechselgeld nach Kassenabrechnung</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussWechselgeld" min="0">
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">Ausgaben (Gesamtbetrag)</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussAusgaben" min="0">
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">Bankeinzahlung (Entnahme)</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussEntnahme" min="0">
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>
     <!-- <div class="row mt-2">
        <label class="col-md-6 col-form-label">Rechnungen (Buchungs-Nummern)</label>
        <div class="col-md-6">
          <fg-input type="text" v-model="editKassenabschlussRechnungen">
          </fg-input>
        </div>
      </div> -->
      <div class="row mt-2">
        <label class="col-md-6 col-form-label">Summe der Rechnungen</label>
        <div class="col-md-6">
          <fg-input type="number" v-model="editKassenabschlussSummeRechnungen">
            <template slot="addonRight">€</template>
          </fg-input>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="modals.editKassenabschluss = false"
            >Abbrechen</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="save">Speichern</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import {
  DatePicker,
  TimeSelect,
  Table,
  TableColumn,
  Tooltip,
  Loading,
  Select,
  Option
} from "element-ui";
import moment from "moment-timezone";
import {
  Collapse,
  CollapseItem,
  TimeLine,
  TimeLineItem,
  Badge,
  Modal
} from "src/components/UIComponents";
import { doc } from "@firebase/firestore";
import store from "../../../../store";

const DENOMINATION_LABELS = {
  Cent1: "1 Cent",
  Cent2: "2 Cent",
  Cent5: "5 Cent",
  Cent10: "10 Cent",
  Cent20: "20 Cent",
  Cent50: "50 Cent",
  Euro1: "1 Euro",
  Euro2: "2 Euro",
  Euro5: "5 Euro",
  Euro10: "10 Euro",
  Euro20: "20 Euro",
  Euro50: "50 Euro",
  Euro100: "100 Euro",
  Euro200: "200 Euro",
  Euro500: "500 Euro",
};

const DENOMINATION_ORDER = [
  "Cent1",
  "Cent2",
  "Cent5",
  "Cent10",
  "Cent20",
  "Cent50",
  "Euro1",
  "Euro2",
  "Euro5",
  "Euro10",
  "Euro20",
  "Euro50",
  "Euro100",
  "Euro200",
  "Euro500",
];

const BANKNOTE_ORDER = ["Euro5", "Euro10", "Euro20", "Euro50", "Euro100", "Euro200", "Euro500"];

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(Loading);

export default {
  components: {
    CollapseItem,
    Collapse,
    TimeLine,
    TimeLineItem,
    Badge,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option
  },

  data() {
    return {
      loading: true,
      reportDateTimeStart: moment().startOf("day").toDate(),
      reportDateTimeEnd: moment().startOf("day").toDate(),
      reportDateHeader: moment().format("DD.MM.YYYY"),
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "Heute",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
        ],
      },
      HT: "",
      Open: "",
      Close: "",
      Weather: "",
      Trainer: "",
      Parcours: [],
      Kasse: [],
      Kassenstart: [],
      HTStart: [],
      HTEnde: [],
      KasseStart: [],
      KasseEnde: [],
      Huette: [],
      VAStart: [],
      VAEnde: [],
      Buero: [],
      VAStartProcessedBy: '',
      VAEndeProcessedBy: '',
      HuetteProcessedBy: '',
      BueroProcessedBy: '',
      HTStartProcessedBy: '',
      HTEndeProcessedBy: '',
      KasseStartProcessedBy: '',
      KasseEndeProcessedBy: '',
      Anmerkungen: [],
      BesondereVorkommnisse: '',
      Toiletten: '',
      EinweisungenCount: 0,
      EinweisungenPersons: 0,
      EinweisungenAvgPersons: 0,
      location: store.getters.userlocation,
      role: store.getters.userrole,
      modals: {
        editKassenabschluss: false,
      },
      // Edit Kassenabschluss
      editKassenabschlussTitle: 0,
      editKassenabschlussKassenbestand: 0,
      editKassenabschlussWechselgeldstart: 0,
      editKassenabschlussEC: 0,
      editKassenabschlussGutscheine: 0,
      editKassenabschlussGutscheineAnzahl: 0,
      editKassenabschlussStornos: 0,
      editKassenabschlussStornosAnzahl: 0,
      editKassenabschlussOnline: 0,
      editKassenabschlussSoll: 0,
      editKassenabschlussWechselgeld: 0,
      editKassenabschlussAusgaben: 0,
      editKassenabschlussEntnahme: 0,
      editKassenabschlussRechnungen: '',
      editKassenabschlussSummeRechnungen: 0,
      editKassenabschlussKassenbestandDenomination: [],
      editKassenabschlussWechselgeldDenomination: [],
      editKassenabschlussBankeinzahlungDenomination: {},
      denominationVisibility: {},
    };
  },
  created() {
    moment.locale("de");

    if (this.$route.params.date) {
      this.reportDateTimeStart = moment(this.$route.params.date, "YYYYMMDD")
        .startOf("day")
        .toDate();
    }
    // get data from reports of selected month
    this.loadReport();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadReport();
      }
    );
  },
  methods: {
    loadReport() {
      this.loading = true
      this.reportDateTimeEnd = moment(this.reportDateTimeStart)
        .endOf("day")
        .toDate();
      this.reportDateHeader = moment(this.reportDateTimeStart).format(
        "DD.MM.YYYY"
      );
      var reportName = moment(this.reportDateTimeStart).format("YYYYMMDD") + '-' + this.location;

      // load general data
      const reportRef = db.collection("tagesreports");
      reportRef
        .doc(reportName)
        .get()
        .then((doc) => {
          if (doc.exists) {
            (this.HT = doc.data().HT || "-"),
              (this.Open = doc.data().Open || "-" + " Uhr"),
              (this.Close = doc.data().Close || "-" + " Uhr"),
              (this.Weather = doc.data().Wetter || "-"),
              (this.Trainer = doc.data().Trainer || "-"),
              (this.BesondereVorkommnisse =
                doc.data().BesondereVorkommnisse || "-");
              this.Toiletten = doc.data().Toiletten || '';
              if (this.Toiletten == '' || this.Toiletten == 'Keine Reinigung') {
                this.Toiletten = '-';
              }
          } else {
            (this.HT = "-"),
              (this.Open = "-"),
              (this.Close = "-"),
              (this.Weather = "-"),
              (this.Trainer = "-"),
              (this.BesondereVorkommnisse = "-");
              this.Toiletten = '-';
          }
        });

      // load parcours check protocoll
      const parcoursRef = db.collection(
        "tagesreports/" + reportName + "/Parcours"
      );
      parcoursRef.orderBy("Position").onSnapshot((snapshotChange) => {
        this.Parcours = [];
        snapshotChange.forEach((doc) => {
          var condition = "";
          if (doc.data().Condition == 1) {
            condition = "Gut";
          }
          if (doc.data().Condition == 2) {
            condition = "Muss beobachtet werden";
          }
          if (doc.data().Condition == 3) {
            condition = "Mängel";
          }
          if (doc.data().Condition == 4) {
            condition = "Gesperrt wegen erheblicher Mängel";
          }
          this.Parcours.push({
            Name: doc.data().Name,
            Inspector: doc.data().Inspector,
            Condition: condition,
            Note: doc.data().Note
          });
        });
      });

      // load einweisungen
      let start = new Date(this.reportDateTimeStart);
      let end = new Date(this.reportDateTimeStart);
      start.setHours(0, 0, 0, 0)
      end.setHours(23, 59, 59, 999)
      const einweisungenRef = db.collection("safetyBriefings");
      einweisungenRef.where('locationID', '==', this.location).where('StartTime', '>=', start).where('StartTime', '<=', end).orderBy("StartTime", "desc").onSnapshot((snapshotChange) => {
        var totalCount = 0;
        var totalPersons = 0;
        snapshotChange.forEach((doc) => {
          totalCount += 1;
          totalPersons += doc.data().Attendees;
        });
        this.EinweisungenCount = totalCount;
        this.EinweisungenPersons = totalPersons;
        if (totalCount > 0) {
          this.EinweisungenAvgPersons = Math.round(totalPersons / totalCount * 10) / 10;
        } else {
          this.EinweisungenAvgPersons = 0;
        }
      });

      // load checklists
      const htstartRef = db.collection(
        "tagesreports/" + reportName + "/HTStart"
      );
      htstartRef.orderBy("position").onSnapshot((snapshotChange) => {
        this.HTStart = [];
        snapshotChange.forEach((doc) => {
          if(doc.id == 'trainer') {
            this.HTStartProcessedBy = doc.data().processedBy
          } else {
            this.HTStart.push({
              Task: doc.data().Task,
              checked: doc.data().checked,
              value: doc.data().value,
              note: doc.data().note || '',
            });
          }
        });
      });

      const htendeRef = db.collection("tagesreports/" + reportName + "/HTEnde");
      htendeRef.orderBy("position").onSnapshot((snapshotChange) => {
        this.HTEnde = [];
        snapshotChange.forEach((doc) => {
          if(doc.id == 'trainer') {
            this.HTEndeProcessedBy = doc.data().processedBy
          } else {
            this.HTEnde.push({
              Task: doc.data().Task,
              checked: doc.data().checked,
              value: doc.data().value,
              note: doc.data().note || '',
            });
          }
        });
      });

      const kassestartRef = db.collection(
        "tagesreports/" + reportName + "/KasseStart"
      );
      kassestartRef.orderBy("position").onSnapshot((snapshotChange) => {
        this.KasseStart = [];
        snapshotChange.forEach((doc) => {
          if(doc.id == 'trainer') {
            this.KasseStartProcessedBy = doc.data().processedBy
          } else {
            this.KasseStart.push({
              Task: doc.data().Task,
              checked: doc.data().checked,
              value: doc.data().value,
            });
          }
        });
      });

      const kasseendeRef = db.collection(
        "tagesreports/" + reportName + "/KasseEnde"
      );
      kasseendeRef.orderBy("position").onSnapshot((snapshotChange) => {
        this.KasseEnde = [];
        snapshotChange.forEach((doc) => {
          if(doc.id == 'trainer') {
            this.KasseEndeProcessedBy = doc.data().processedBy
          } else {
            this.KasseEnde.push({
              Task: doc.data().Task,
              checked: doc.data().checked,
              value: doc.data().value,
            });
          }
        });
      });

      const vastartRef = db.collection(
        "tagesreports/" + reportName + "/VAStart"
      );
      vastartRef.orderBy("position").onSnapshot((snapshotChange) => {
        this.VAStart = [];
        snapshotChange.forEach((doc) => {
          if(doc.id == 'trainer') {
            this.VAStartProcessedBy = doc.data().processedBy
          } else {
            this.VAStart.push({
              Task: doc.data().Task,
              checked: doc.data().checked,
              value: doc.data().value,
            });
          }
        });
      });
      const vaendeRef = db.collection(
        "tagesreports/" + reportName + "/VAEnde"
      );
      vaendeRef.orderBy("position").onSnapshot((snapshotChange) => {
        this.VAEnde = [];
        snapshotChange.forEach((doc) => {
          if(doc.id == 'trainer') {
            this.VAEndeProcessedBy = doc.data().processedBy
          } else {
            this.VAEnde.push({
              Task: doc.data().Task,
              checked: doc.data().checked,
              value: doc.data().value,
            });
          }
        });
      });

      const bueroRef = db.collection(
        "tagesreports/" + reportName + "/Buero"
      );
      bueroRef.orderBy("position").onSnapshot((snapshotChange) => {
        this.Buero = [];
        snapshotChange.forEach((doc) => {
          if(doc.id == 'trainer') {
            this.BueroProcessedBy = doc.data().processedBy
          } else {
            this.Buero.push({
              Task: doc.data().Task,
              checked: doc.data().checked,
              value: doc.data().value,
            });
          }
        });
      });

      const huetteRef = db.collection(
        "tagesreports/" + reportName + "/Huette"
      );
      huetteRef.orderBy("position").onSnapshot((snapshotChange) => {
        this.Huette = [];
        snapshotChange.forEach((doc) => {
          if(doc.id == 'trainer') {
            this.HuetteProcessedBy = doc.data().processedBy
          } else {
            this.Huette.push({
              Task: doc.data().Task,
              checked: doc.data().checked,
              value: doc.data().value,
            });
          }
        });
      });

      // load Kassenstart
      const kassenStartRef = db.collection(
        "tagesreports/" + reportName + "/Kassenstart"
      );
      kassenStartRef.onSnapshot((snapshotChange) => {
        this.Kassenstart = [];
        snapshotChange.forEach((doc) => {
          var wechselgeld = ''
          if(doc.data().wechselgeldKorrekt == true) {
            wechselgeld = "Korrekt"
          } else {
            wechselgeld = "Nicht korrekt"
          }
          this.Kassenstart.push({
            Title: doc.id,
            Trainer: doc.data().trainerKassenstart,
            Timestamp: moment(new Date(doc.data().Timestamp.seconds * 1000))
                  .format("HH:mm")
                  .toString(),
            WechselgeldKorrekt: wechselgeld,
            Abweichung: doc.data().beschreibungAbweichung || ""
          })
        })
        this.loading = false
      });
      // load Kasse
      const kasseRef = db.collection(
        "tagesreports/" + reportName + "/Kassenabschluss"
      );
      kasseRef.orderBy("Kasse").onSnapshot((snapshotChange) => {
        this.Kasse = [];
        snapshotChange.forEach((doc) => {
          var title = ''
          if(doc.data().isValid) {
            title = doc.id
          } else {
            title = doc.id + ' (ungültig)'
          }
          this.Kasse.push({
            Title: title,
            Date: doc.data().Date,
            isValid: doc.data().isValid,
            Timestamp: moment(new Date(doc.data().Timestamp.seconds * 1000))
                .format("DD.MM.YY HH:mm:ss")
                .toString(),
            Kasse: doc.data().Kasse,
            Ausgaben: parseFloat(doc.data().Ausgaben),
            Bankeinzahlung: doc.data().Bankeinzahlung,
            ECSchnitt: doc.data().ECSchnitt,
            Gutscheine: doc.data().Gutscheine,
            GutscheineAnzahl: doc.data().GutscheineAnzahl || 0,
            Stornos: parseFloat(doc.data().Stornos || 0),
            StornosAnzahl: doc.data().StornosAnzahl || 0,
            Kassenbestand: doc.data().Kassenbestand,
            KassenbestandDenomination: doc.data().KassenbestandDenomination,
            Kassendifferenz: doc.data().Kassendifferenz,
            KassenTrainer: doc.data().Kassentrainer,
            HT: doc.data().HT,
            banktransferDoc: doc.data().banktransferDoc,
            Online: doc.data().Online,
            Rechnungen: doc.data().Rechnungen,
            SollBestand: doc.data().SollBestand,
            TrainerBankeinzahlung: doc.data().TrainerBankeinzahlung,
            TrainerRecount: doc.data().TrainerRecount,
            WechselgeldEnde: doc.data().WechselgeldEnde,
            WechselgeldDenomination:
              doc.data().WechselgeldDenomination ||
              doc.data().WechselgeldEndeDenomination ||
              [],
            BankeinzahlungDenomination:
              doc.data().BankeinzahlungDenomination ||
              doc.data().bankeinzahlungDenomination ||
              doc.data().BanktransferDenomination ||
              doc.data().banktransferDenomination ||
              {
                Euro5: doc.data().Euro5Bank || 0,
                Euro10: doc.data().Euro10Bank || 0,
                Euro20: doc.data().Euro20Bank || 0,
                Euro50: doc.data().Euro50Bank || 0,
                Euro100: doc.data().Euro100Bank || 0,
                Euro200: doc.data().Euro200Bank || 0,
                Euro500: doc.data().Euro500Bank || 0,
              },
            Wechselgeldstart: doc.data().Wechselgeldstart,
            SummeRechnungen: doc.data().SummeRechnungen || 0,
            ZFin: doc.data().ZFin,
            ECPercent: (doc.data().ECSchnitt * 100) / doc.data().ZFin || 0,
            OnlinePercent: (doc.data().Online * 100) / doc.data().ZFin || 0,
            CashlessTotal: doc.data().Online + +doc.data().ECSchnitt,
            CashlessPercent:
              ((doc.data().Online + +doc.data().ECSchnitt) * 100) /
              doc.data().ZFin || 0, 
          });
        });
        this.loading = false
      });

      // load Anmerkungen
      const anmerkungenRef = db.collection("anmerkungen");
      anmerkungenRef
        .where("timestamp", ">=", this.reportDateTimeStart)
        .where("timestamp", "<=", this.reportDateTimeEnd)
        .where('locationID', '==', this.location)
        .orderBy("timestamp", "desc")
        .onSnapshot((snapshotChange) => {
          this.Anmerkungen = [];
          snapshotChange.forEach((doc) => {
            var type = null;
            if (doc.data().important) {
              type = "danger";
            } else {
              type = "success";
            }
            this.Anmerkungen.push({
              key: doc.id,
              text: doc.data().text,
              important: doc.data().important,
              timestamp: moment(new Date(doc.data().timestamp.seconds * 1000))
                .format("dddd, DD. MMM HH:mm")
                .toString(),
              type: type,
            });
          });
        });
    },
    editKasse(index) {
      this.editKassenabschlussDate = this.Kasse[index].Date
      this.editKassenabschlussKasse = this.Kasse[index].Kasse
      this.editKassenabschlussTitle = this.Kasse[index].Title
      this.editKassenabschlussWechselgeldstart = this.Kasse[index].Wechselgeldstart.toFixed(2)
      this.editKassenabschlussKassentrainer = this.Kasse[index].KassenTrainer
      this.editKassenabschlussHT = this.Kasse[index].HT
      this.editKassenabschlussTrainerBankeinzahlung = this.Kasse[index].TrainerBankeinzahlung
      this.editKassenabschlussTrainerRecount = this.Kasse[index].TrainerRecount
      this.editKassenabschlussKassenbestand = this.Kasse[index].Kassenbestand.toFixed(2)
      this.editKassenabschlussEC = this.Kasse[index].ECSchnitt.toFixed(2)
      this.editKassenabschlussGutscheine = this.Kasse[index].Gutscheine.toFixed(2)
      this.editKassenabschlussGutscheineAnzahl = this.Kasse[index].GutscheineAnzahl.toFixed(0)
      this.editKassenabschlussStornos = this.Kasse[index].Stornos.toFixed(2)
      this.editKassenabschlussStornosAnzahl = this.Kasse[index].StornosAnzahl.toFixed(0)
      this.editKassenabschlussOnline = this.Kasse[index].Online.toFixed(2)
      this.editKassenabschlussSoll = this.Kasse[index].SollBestand.toFixed(2)
      this.editKassenabschlussWechselgeld = this.Kasse[index].WechselgeldEnde.toFixed(2)
      this.editKassenabschlussAusgaben = this.Kasse[index].Ausgaben.toFixed(2)
      this.editKassenabschlussEntnahme = this.Kasse[index].Bankeinzahlung.toFixed(2)
      this.editKassenabschlussRechnungen = this.Kasse[index].Rechnungen
      this.editKassenabschlussbanktransferDoc = this.Kasse[index].banktransferDoc
      this.editKassenabschlussSummeRechnungen = this.Kasse[index].SummeRechnungen.toFixed(2)
      this.editKassenabschlussKassenbestandDenomination = this.Kasse[index].KassenbestandDenomination || []
      this.editKassenabschlussWechselgeldDenomination = this.Kasse[index].WechselgeldDenomination || []
      this.editKassenabschlussBankeinzahlungDenomination = this.Kasse[index].BankeinzahlungDenomination || {}
      // show modal
      this.modals.editKassenabschluss = true
    },
    save() {
      const kassenabschlussRef = db.collection(
        "tagesreports/" + moment(this.reportDateTimeStart).format("YYYYMMDD") + '-' + this.location + "/Kassenabschluss"
      );
      const banktransferRef = db.collection("banktransfer");

      var batch = db.batch();

      batch.set(kassenabschlussRef.doc(this.editKassenabschlussTitle + '-1'), {
        Date: this.editKassenabschlussDate,
        Kasse: this.editKassenabschlussKasse,
        Wechselgeldstart: parseFloat(this.editKassenabschlussWechselgeldstart),
        Kassentrainer: this.editKassenabschlussKassentrainer,
        HT: this.editKassenabschlussHT,
        TrainerBankeinzahlung: this.editKassenabschlussTrainerBankeinzahlung,
        TrainerRecount: this.editKassenabschlussTrainerRecount ,
        Bankeinzahlung: parseFloat(this.editKassenabschlussEntnahme),
        Kassenbestand: parseFloat(this.editKassenabschlussKassenbestand),
        WechselgeldEnde: parseFloat(this.editKassenabschlussWechselgeld),
        ECSchnitt: parseFloat(this.editKassenabschlussEC),
        SollBestand: parseFloat(this.editKassenabschlussSoll),
        Gutscheine: parseFloat(this.editKassenabschlussGutscheine),
        GutscheineAnzahl: parseFloat(this.editKassenabschlussGutscheineAnzahl),
        Stornos: parseFloat(this.editKassenabschlussStornos),
        StornosAnzahl: parseFloat(this.editKassenabschlussStornosAnzahl),
        Online: parseFloat(this.editKassenabschlussOnline),
        Ausgaben: parseFloat(this.editKassenabschlussAusgaben),
        SummeRechnungen: parseFloat(this.editKassenabschlussSummeRechnungen),
        Rechnungen: this.editKassenabschlussRechnungen,
        KassenbestandDenomination: this.editKassenabschlussKassenbestandDenomination,
        WechselgeldDenomination: this.editKassenabschlussWechselgeldDenomination,
        WechselgeldEndeDenomination: this.editKassenabschlussWechselgeldDenomination,
        BankeinzahlungDenomination: this.editKassenabschlussBankeinzahlungDenomination,
        ZFin: parseFloat(parseFloat(this.editKassenabschlussEC) + +parseFloat(this.editKassenabschlussSoll) + +parseFloat(this.editKassenabschlussAusgaben) + +parseFloat(this.editKassenabschlussEntnahme) + +parseFloat(this.editKassenabschlussSummeRechnungen) + +parseFloat(this.editKassenabschlussOnline) - parseFloat(this.editKassenabschlussWechselgeldstart)),
        Kassendifferenz: this.editKassenabschlussKassenbestand - this.editKassenabschlussEntnahme -this.editKassenabschlussSoll,
        banktransferDoc: this.editKassenabschlussbanktransferDoc,
        Timestamp: new Date(),
        isValid: true
      });
      batch.update(kassenabschlussRef.doc(this.editKassenabschlussTitle), { isValid: false })

      batch.update(banktransferRef.doc(this.editKassenabschlussbanktransferDoc), {
        betrag: parseFloat(this.editKassenabschlussEntnahme),
        denomination: this.editKassenabschlussBankeinzahlungDenomination,
        confirmed: false,
      });

      batch.commit().then(() => {
        // hide modal
        this.modals.editKassenabschluss = false
      })     
    },
    viewEinweisungen() {
      this.$router.push({
        name: "Einweisungen",
        params: { date: moment(this.reportDateTimeStart).format("YYYY-MM-DD") },
      });
    },
    denominationToggleKey(index, section) {
      return `${index}-${section}`;
    },
    isDenominationVisible(index, section) {
      return !!this.denominationVisibility[this.denominationToggleKey(index, section)];
    },
    toggleDenomination(index, section) {
      const key = this.denominationToggleKey(index, section);
      this.$set(this.denominationVisibility, key, !this.denominationVisibility[key]);
    },
    normalizeDenominationMap(denomination) {
      if (!denomination) {
        return {};
      }

      if (Array.isArray(denomination)) {
        return denomination.reduce((acc, item) => {
          if (item && typeof item === "object") {
            const key = Object.keys(item)[0];
            if (key) {
              acc[key] = Number(item[key] || 0);
            }
          }
          return acc;
        }, {});
      }

      if (typeof denomination === "object") {
        const normalized = {};
        Object.keys(denomination).forEach((key) => {
          normalized[key] = Number(denomination[key] || 0);
        });
        return normalized;
      }

      return {};
    },
    denominationValueByKey(key) {
      if (key.startsWith("Cent")) {
        return Number(key.replace("Cent", "")) / 100;
      }
      if (key.startsWith("Euro")) {
        return Number(key.replace("Euro", ""));
      }
      return 0;
    },
    getDenominationEntries(denomination, options = {}) {
      const map = this.normalizeDenominationMap(denomination);
      const order = options.banknotesOnly ? BANKNOTE_ORDER : DENOMINATION_ORDER;

      return order
        .map((key) => {
          const count = Number(map[key] || 0);
          const unitValue = this.denominationValueByKey(key);

          return {
            key,
            label: DENOMINATION_LABELS[key] || key,
            count,
            unitValue,
            totalValue: count * unitValue,
          };
        })
        .filter((entry) => entry.count > 0);
    },
    hasDenomination(denomination, options = {}) {
      return this.getDenominationEntries(denomination, options).length > 0;
    },
    getWechselgeldDenominationEntries(abschluss) {
      return this.getDenominationEntries(abschluss.WechselgeldDenomination);
    },
    hasWechselgeldDenomination(abschluss) {
      return this.getWechselgeldDenominationEntries(abschluss).length > 0;
    },
    formatMoney(value) {
      return Number(value || 0)
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €";
    },
  },
};
</script>
<style>
.card-collapse .card .card-header {
  font-weight: bold;
}
.checklist-note {
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 0.9rem;
  color: #555;
  white-space: normal;
  word-break: break-word;
}
.checklist-note i {
  color: #15A34A;
  margin-top: 2px;
  flex-shrink: 0;
}
.denomination-toggle {
  font-size: 0.85rem;
}
.denomination-box {
  margin-top: 8px;
  border: 1px solid #e7e7e7;
  border-radius: 6px;
  padding: 8px;
  background: #fafafa;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 6px;
}
.denomination-chip {
  border: 1px solid #e8edf3;
  background: #fff;
  border-radius: 6px;
  padding: 6px 8px;
}
.denomination-chip-label {
  font-size: 0.78rem;
  color: #6b7280;
  line-height: 1.1;
}
.denomination-chip-count {
  margin-top: 2px;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.1;
}
.denomination-chip-total {
  margin-top: 2px;
  font-size: 0.82rem;
  color: #334155;
  line-height: 1.1;
}
</style>
